import type { ElementType } from 'react';

import { View } from '#internal/components/View';
import { resolveSx } from '#internal/systems/index';
import { createClassName } from '#internal/utils/classname';

import styles from './ProgressBar.module.css';

import type { Props } from './';

const classnameDefault = 'ui-ProgressBar';

export const ProgressBar = <T extends ElementType>(props: Props<T>) => {
  const {
    as = 'div',
    className,
    value,
    size = 'medium',
    variant = 'default',
    max,
    title,
    label,
    sx,
    style,
    ...restProps
  } = props;

  const modifiers = {
    size: size && styles[`size-${size}`],
    variant: styles[`variant-${variant}`],
  };

  const classname = createClassName({
    styles,
    baseName: classnameDefault,
    modifiers,
    className,
  });

  const spacingStyle = resolveSx({ sx });

  const customStyles = { ...spacingStyle, ...style };

  const percent = (value / max) * 100;

  return (
    <View as={as} className={classname} style={customStyles} {...restProps}>
      <div className={styles.box}>
        <div className={styles.bar} style={{ width: `${percent}%` }}></div>
      </div>
      {(title || label) && (
        <div className={styles.header}>
          {title && <div className={styles.title}>{title}</div>}
          {label && <div className={styles.label}>{label}</div>}
        </div>
      )}
    </View>
  );
};
